<template>
  <div class="category-slider-widget" v-if="categories.length">
    <div class="category-slider-header" v-if="title">
      <h2 class="category-slider-title">{{ title }}</h2>
    </div>

    <div class="category-slider-wrapper"
         @mouseenter="showArrows = true"
         @mouseleave="showArrows = false">

      <!-- Navigation Arrows -->
      <button class="slider-arrow slider-arrow-prev"
              :class="{ 'is-visible': showArrows && !isBeginning }"
              @click="slidePrev"
              aria-label="Vorherige Kategorie">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="15 18 9 12 15 6"></polyline>
        </svg>
      </button>

      <button class="slider-arrow slider-arrow-next"
              :class="{ 'is-visible': showArrows && !isEnd }"
              @click="slideNext"
              aria-label="Nächste Kategorie">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="9 18 15 12 9 6"></polyline>
        </svg>
      </button>

      <!-- Swiper Container -->
      <div class="swiper" ref="swiperContainer">
        <div class="swiper-wrapper">
          <div class="swiper-slide"
               v-for="(category, index) in categories"
               :key="category.id || index">
            <a :href="category.url" class="category-slide-link">
              <div class="category-slide-image-wrapper">
                <img :src="category.image"
                     :alt="category.name"
                     class="category-slide-image"
                     loading="lazy">
              </div>
              <span class="category-slide-name">{{ category.name }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper';

export default {
  name: 'CategorySliderWidget',

  props: {
    title: {
      type: String,
      default: ''
    },
    categories: {
      type: Array,
      default: () => []
      // Erwartetes Format:
      // [{ id: 1, name: 'Teddy Stoffe', image: '/path/to/image.jpg', url: '/kategorie/teddy' }]
    },
    slidesPerView: {
      type: [Number, String],
      default: 7.5 // .5 für den Anschnitt-Effekt
    },
    spaceBetween: {
      type: Number,
      default: 16
    },
    breakpoints: {
      type: Object,
      default: () => ({
        320: { slidesPerView: 2.3, spaceBetween: 10 },
        480: { slidesPerView: 3.3, spaceBetween: 12 },
        768: { slidesPerView: 4.5, spaceBetween: 14 },
        1024: { slidesPerView: 5.5, spaceBetween: 16 },
        1280: { slidesPerView: 6.5, spaceBetween: 16 },
        1440: { slidesPerView: 7.5, spaceBetween: 16 }
      })
    }
  },

  data() {
    return {
      swiper: null,
      showArrows: false,
      isBeginning: true,
      isEnd: false
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.initSwiper();
    });
  },

  beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
    }
  },

  methods: {
    initSwiper() {
      if (!this.$refs.swiperContainer) return;

      this.swiper = new Swiper(this.$refs.swiperContainer, {
        slidesPerView: this.slidesPerView,
        spaceBetween: this.spaceBetween,
        breakpoints: this.breakpoints,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        on: {
          init: (swiper) => {
            this.updateNavState(swiper);
          },
          slideChange: (swiper) => {
            this.updateNavState(swiper);
          },
          reachBeginning: () => {
            this.isBeginning = true;
          },
          reachEnd: () => {
            this.isEnd = true;
          },
          fromEdge: () => {
            this.isBeginning = false;
            this.isEnd = false;
          }
        }
      });
    },

    updateNavState(swiper) {
      this.isBeginning = swiper.isBeginning;
      this.isEnd = swiper.isEnd;
    },

    slideNext() {
      if (this.swiper) {
        this.swiper.slideNext();
      }
    },

    slidePrev() {
      if (this.swiper) {
        this.swiper.slidePrev();
      }
    }
  }
};
</script>
